import React, { useEffect, useState } from 'react';
import { Fab, Grid, Typography, Zoom, styled, useScrollTrigger } from '@mui/material';
import ImagePrivacy from "assets/images/Parallax/SessionH/Fossil_Privacypolicy.png";
import { FnAxios, I18n } from "utilities/utilities";
import HideAppBar from 'view/FrontEnd/HomePage/components/HideAppBar';
import BKImageDashboard from "assets/images/Parallax/SessionG/BK_Dashboard.png";
import { HiOutlineArrowNarrowUp } from 'react-icons/hi';
import { ApiCookie } from 'enum/api';
import AccordionCustom from 'components/Accordion/index';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

const ContainerBG = styled("div")({
    backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${BKImageDashboard})`,
    backgroundPositionX: "center",
    backgroundPosittionY: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed"
});

const Privacypolicy = () => { //PDPA
    const AxiosFn = FnAxios();
    const [nModeID, setnModeID] = useState(null); //1 = Website Security Policy = นโยบายการรักษาความมั่นคงปลอดภัยเว็บไซต์ / 2 Privacy Policy = นโยบายส่วนบุคคล
    const [arrDataPDPA, setarrDataPDPA] = useState<any>([]);

    useEffect(() => {
        let sPathName = window.location.search;
        if (sPathName != undefined) {
            let sMode_ = sPathName.replace("?", "") ?? null;
            setnModeID(sMode_ ? parseInt(sMode_) : null);
            handleDataPDPA();
        }
    }, [])

    const handleDataPDPA = () => {
        AxiosFn.Get(ApiCookie.Privacypolicy, { nPDPA_ID: nModeID }, (result) => {
            setarrDataPDPA([...result.objResult]);
        })
    };

    return (
        <React.Fragment>
            <HideAppBar />
            <div className='container-image-show-policy'>
                <Grid container alignItems='center' item xs={12}>
                    <Grid item xs={12} className="session-h-container-policy" sx={{ backgroundImage: `url(${ImagePrivacy})`, }}>
                        <div className='image-title-policy'>
                            <Typography>{I18n.SetText("policy")}</Typography>
                        </div>
                        {/* <Grid item container xs={12} md={12} justifyContent={"center"} alignItems={"center"} alignContent={"center"} style={{marginTop: '13%'}}> 
                        <Typography>{I18n.SetText("policy")}</Typography>
                    </Grid> */}
                    </Grid>
                    <Grid item xs={12}>
                        <ContainerBG>
                            <div className="backgournd-content-children-policy">
                                <Grid item container xs={12} md={12} spacing={3}>
                                    {arrDataPDPA.map((item, index) => {
                                        return (
                                            <Grid item xs={12} md={12} key={"P_" + item.nPDPA_ID} >
                                                <AccordionCustom header={item.sTitle} isExpanded={nModeID === item.nPDPA_ID || nModeID === null}>
                                                    <FroalaEditorView model={item.sDetail + ""} />
                                                </AccordionCustom>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            </div>
                        </ContainerBG>
                    </Grid>
                </Grid>

                <ScrollToTop>
                    <Fab
                        color="error"
                        size="large"
                        sx={{
                            flexDirection: "column",
                            borderRadius: "16px",
                            width: "35px",
                            height: "70px",
                            textAlign: "center",
                            lineHeight: "1",
                            fontSize: "13px",
                            backgroundColor: "#ff0000"
                        }}
                    >
                        <HiOutlineArrowNarrowUp size="25" />
                        <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                            UP
                        </span>
                    </Fab>
                </ScrollToTop>
            </div>
        </React.Fragment>
    )
}
export default Privacypolicy;

const ScrollToTop = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 300,
    });

    const handleClick = (event) => {
        window.scrollTo({ top: 0, behavior: `smooth` })
    };

    return (
        <Zoom in={trigger}>
            <div
                onClick={handleClick}
                role="presentation"
                style={{
                    position: "fixed",
                    bottom: "12px",
                    right: "15px",
                    width: "46.7px",
                    height: "87.5px",
                }}
            >
                {children}
            </div>
        </Zoom>
    );
};
